import { Route, Routes, useLocation } from "react-router-dom";
import Almoni from "./assets/fonts/Almoni/aaa-fonts Almoni/almoni-medium-aaa.otf";
import Arbel from "./assets/fonts/Arbel/ArbelG-Medium.otf";
import Footer from "./domain/Common/Layout/Footer/Footer";
import Header from "./domain/Common/Layout/Header/Header";
import Main from "./domain/Common/Layout/Main/Main";
import DetailsContainer from "./domain/Common/Layout/Header/components/DetailsContainer";
import {
  Handles,
  HandlesToMobile,
  SwiperData1,
  SwiperData1ToMobile,
  SwiperData2,
  SwiperData2ToMobile,
  SwiperDataDefault,
  SwiperDataMobile,
  navList,
  newProjectsList,
  completedProjectsData,
  underConstructionProjectsData,
  SwiperDataRotschild,
  SwiperDataRotschildMobile,
  SwiperDataGordon,
  SwiperDataGordonMobile,
  SwiperDataHirshenberg,
  SwiperDataHirshenbergMobile,
  projectsPage1Data,
  projectsPage2Data,
  projectsPage3Data,
} from "./domain/Constants/data";
import ProjectsGallery from "./domain/Common/Layout/Main/components/ProjectsGallery";
import MySwiper from "./domain/Common/Layout/Main/components/Swiper";
import HandleViewer from "./domain/Common/Layout/Main/components/HandleViewer";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  @font-face {
    font-family: 'Almoni';
    src: url(${Almoni}) format('truetype');
  }
  @font-face {
    font-family: 'Arbel';
    src: url(${Arbel}) format('truetype');
  }
  `;
function App() {
  const isMobile = window.matchMedia("(max-width: 600px)").matches;
  const isHDScreen = window.matchMedia("(min-width: 1441px)").matches;
  const isHomePage = useLocation().pathname === "/";
  const isHandlesPage = useLocation().pathname === "/pirzul";
  const isProjectsPage = ["/projects", "/projects1", "/projects2", "/projects3"].includes(useLocation().pathname);
  const currentPage = useLocation().pathname;
  const getImages = () => {
    if (isMobile) {
      if (currentPage === "/sderot") return SwiperData2ToMobile;
      if (currentPage === "/projects") return SwiperData1ToMobile;
      if (currentPage === "/rotschild101") return SwiperDataRotschildMobile;
      if (currentPage === "/gordon82") return SwiperDataGordonMobile;
      if (currentPage === "/hirshenberg5") return SwiperDataHirshenbergMobile;
      else return SwiperDataMobile;
    } else if (currentPage === "/sderot") return SwiperData2;
    if (currentPage === "/projects") return SwiperData1;
    if (currentPage === "/rotschild101") return SwiperDataRotschild;
    if (currentPage === "/gordon82") return SwiperDataGordon;
    if (currentPage === "/hirshenberg5") return SwiperDataHirshenberg;
    else return SwiperDataDefault;
  };
  const getWidth = () => {
    if (isMobile) return "90%";
    else if (isHandlesPage) return "78%";
    else if (isHDScreen) return "85%";
    else return "91%";
  };
  return (
    <div className="App">
      <GlobalStyle />
      <Header />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route
          path="/projects"
          element={
            <ProjectsGallery projects={completedProjectsData} title="פרויקטים נוספים" />
          }
        />
        <Route
          path="/projects1"
          element={
            <ProjectsGallery projects={projectsPage1Data} title="פרויקטים מוכנים" />
          }
        />
        <Route
          path="/projects2"
          element={
            <ProjectsGallery projects={projectsPage2Data} title="פרויקטים בבניה" />
          }
        />
        <Route
          path="/projects3"
          element={
            <ProjectsGallery projects={projectsPage3Data} title="פרויקטים נוספים" />
          }
        />
        <Route
          path="/sderot"
          element={<DetailsContainer item={navList[1]} />}
        />
        <Route
          path="/pirzul"
          element={<DetailsContainer item={navList[2]} />}
        />
        <Route
          path="/rotschild101"
          element={<DetailsContainer item={newProjectsList[0]} />}
        />
        <Route
          path="/gordon82"
          element={<DetailsContainer item={newProjectsList[1]} />}
        />
        <Route
          path="/hirshenberg5"
          element={<DetailsContainer item={newProjectsList[2]} />}
        />
      </Routes>
      {!isProjectsPage && (
        <div
          style={{
            background: !isHomePage && "#EECCA2",
            padding: isMobile ? "1px 0 1px" : "1px 0 1px",
            margin: "auto",
          }}
        >
          <div
            style={{
              width: getWidth(),
              margin: " 0 auto 0px ",
            }}
          >
            {isHandlesPage ? (
              <HandleViewer handles={isMobile ? HandlesToMobile : Handles} />
            ) : (
              <MySwiper key={Math.random()} images={getImages()} />
            )}
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default App;
